export enum Subpages {
  TOTAL_MATCHES = 'total-matches',
  REVIEW = 'hiring-manager/review',
  ADVANCED = 'hiring-manager/advanced',
  REJECTED = 'hiring-manager/rejected',
  SHORTLIST = 'shortlist',
  DESCRIPTION = 'description',
  NOTES = 'notes',
  ATTACHMENTS = 'attachments',
  REJECTED_DA = 'rejected-da',
}
